import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

// Split Text Animation
export const SplitText = ({ children, delay = 0, className = '' }) => {
    const words = children.split(' ');
    
    return (
        <span className={className}>
            {words.map((word, i) => (
                <motion.span
                    key={i}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                        duration: 0.5,
                        delay: delay + i * 0.1,
                        ease: [0.22, 1, 0.36, 1]
                    }}
                    style={{ display: 'inline-block', marginRight: '0.25em' }}
                >
                    {word}
                </motion.span>
            ))}
        </span>
    );
};

// Typewriter Effect
export const TypewriterText = ({ text, speed = 50, className = '' }) => {
    const [displayedText, setDisplayedText] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (currentIndex < text.length) {
            const timeout = setTimeout(() => {
                setDisplayedText(prev => prev + text[currentIndex]);
                setCurrentIndex(prev => prev + 1);
            }, speed);

            return () => clearTimeout(timeout);
        }
    }, [currentIndex, text, speed]);

    return (
        <span className={className}>
            {displayedText}
            <motion.span
                animate={{ opacity: [1, 0] }}
                transition={{ duration: 0.8, repeat: Infinity, repeatType: 'reverse' }}
            >
                |
            </motion.span>
        </span>
    );
};

// Glitch Text Effect
export const GlitchText = ({ children, className = '' }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <motion.span
            className={`glitch-text ${className}`}
            onHoverStart={() => setIsHovered(true)}
            onHoverEnd={() => setIsHovered(false)}
            animate={isHovered ? {
                x: [0, -2, 2, -2, 2, 0],
                y: [0, 2, -2, 2, -2, 0],
            } : {}}
            transition={{ duration: 0.3 }}
            style={{ position: 'relative', display: 'inline-block' }}
        >
            <span className="glitch-text-main">{children}</span>
            <span className="glitch-text-shadow glitch-text-shadow-1">{children}</span>
            <span className="glitch-text-shadow glitch-text-shadow-2">{children}</span>
        </motion.span>
    );
};

// Fade In Text
export const FadeInText = ({ children, delay = 0, duration = 0.6, className = '' }) => {
    return (
        <motion.span
            className={className}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration, delay }}
        >
            {children}
        </motion.span>
    );
};

